import LoginForm from "../Components/forms/LoginForm";
import {Link} from "react-router-dom"

const Login = () => {
    return (
        <div className="min-h-screen font-sans">
            <h1 className="text-2xl my-6 text-center">Iniciar Sesion</h1>
            <LoginForm />
            <div className="max-w-sm m-auto space-y-2 mt-8 flex flex-col text-lg">
                <Link to={'/register'} className="text-sky-400 hover:text-yellow-cdg">Crear cuenta</Link>
                <Link to={'/rescue-pass'} className="text-sky-400 hover:text-yellow-cdg">Generar nueva contraseña / Recuperar</Link>
            </div>
        </div>
    );
};

export default Login;
